<template>
	<div id="subjectList"  class="public-content">
		<div class="subjectList-btn">
      <el-button
        class='minButton'
        size="small"
        @click='importInData(i)'
        v-for='i in importButton' :key='i.id'
      >
        {{i.name}}
      </el-button>
      <el-button class='minButton' size="small" @click="handleExpandAll">
      	<span v-if='!ishandleExpandAll'>展开所有</span>
      	<span v-else>收起所有</span>
      </el-button>
      <el-button class='minButton' size="small" @click="addSubject">添加</el-button>
    </div>
		<el-tabs type="card" v-model="tabVal" @tab-click="handleClick">
			<el-tab-pane v-for="(item,index) in listLabel.typelist" :key="index" :label="item" :name="item" >

			</el-tab-pane>
		</el-tabs>
		<!-- 公共table 样式 -->
		<div class="table-item-public">
			<el-table :data="tableData" v-loading="loading" border size="small" style="width:100%"
			    :height="'calc(100%)'"
				:row-key="getRowKeys" lazy  :indent="20" v-if="refash" :default-expand-all='ishandleExpandAll'
				:expand-row-keys = "expandRow" :row-style='handleTableRowStyle'
			>
				<el-table-column label="编码" prop="code" align="left">
					<!-- <template slot-scope="scope">
						<span v-if="scope.row.childs && scope.row.childs.length <= 0">{{scope.row.code}}</span>
						<el-button v-else type="text" @click="addChildNode(scope.row)"><i class="el-icon-arrow-down"></i>{{scope.row.code}}</el-button>
					</template> -->
				</el-table-column>
				<el-table-column label="名称" prop="name" align="center"></el-table-column>
				<el-table-column label="余额方向" prop="creditDirection" align="center"></el-table-column>
				<el-table-column label="辅助核算" align="center">
					<template slot-scope="scope">
						{{scope.row.auxiliary!= null ? scope.row.auxiliary.join(',') : scope.row.auxiliary}}
					</template>
				</el-table-column>
				<el-table-column label="外币核算" align="center">
					<template slot-scope="scope">
						{{scope.row.foreignCurrencys!= null ?  scope.row.foreignCurrencys.join(',') : scope.row.foreignCurrencys}}
					</template>
				</el-table-column>
				<el-table-column label="数量核算" prop="unit" align="center"></el-table-column>
				<el-table-column label="操作" align="left">
					<template slot-scope="scope">
			            <div v-if="scope.row.attribute != 'readOnly'">
			              <el-button type="text" @click="addChildEditor(scope.row)">新增下级</el-button>
			              <el-button type="text" @click="editorEditor(scope.row)" v-show="!scope.row.hasChild || scope.row.level > 1">修改</el-button>
			              <el-button type="text" @click="deleteDelete(scope.row)" v-show="!scope.row.hasChild" style="color: red;">删除</el-button>
			              <el-button type="text" @click="sealUpEditor(scope.row)">{{scope.row.sealed == '1' ? '解封' : '封存'}}</el-button>
			            </div>
			            <div v-else>
			            	<el-button type="text" style='color: #fff;'>无</el-button>
			            </div>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<!-- 科目弹出层-->
		<subject-dialog v-if="dialog" :show="dialog" :subjectData="formDatas" @on-close-modal="cancel" @on-save-success="cancel1"></subject-dialog>

		<!-- 导入科目 -->
		<el-dialog
			title="导入科目" :visible.sync="importFilesSubject" width="400px" :close-on-click-modal="false" class='subject_dialog_import'>
			<div v-loading='isImportFilesLoading' element-loading-text="正在上传文件...">
				<div class="fliesUplaod"  >
					<h4 class='color333'>下载模板</h4>
					<el-button type="text" class='handleDownload' @click='handleDownload_MB'>点击下载模板</el-button>
					<h4 class='color333'>导入科目</h4>
					<div class="uploads">
						<el-upload
						  drag
						  action="https://jsonplaceholder.typicode.com/posts/"
						  :show-file-list='true'
						  :auto-upload="false"
						  :on-change="OnChange"
						  :on-remove="OnRemove"
						  :before-remove="beforeRemove"
						  :limit='handleLimit'
						  ref='upload'
						  >
						  <i class="el-icon-upload"></i>
						  <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
						  <div class="el-upload__tip" slot="tip">只能上传.xls/.xlsx文件，且不超过5M</div>
						</el-upload>
					</div>
				</div>
				<div slot="footer" class="dialog-footer">
					<el-button size="small" class='minButton' @click="handleUploadAdd">确定导入</el-button>
				</div>
			</div>
		</el-dialog>

		<!-- 科目智能导入 -->
		<AIImport ref="AIImports" :typeList="listLabel.typelist" @successImport="init" @angry="AIangry"></AIImport>
    <ai-angry ref="aiAngrys" @success="ai_success" @error="closeDialog" :again="true"></ai-angry>
	</div>
</template>

<script>
import subjectDialog from '@/components/dialog/subjectDialog'
import AIImport from "@/components/AIImport"
import aiAngry from "@/components/AIImport/aiAngry.vue"
export default {
	data(){
		return {
      isAIangry:false,
			importButton:[],
			fileList:[],  // 文件
			handleLimit: 1,        // 上传文件数
			isImportFilesLoading: false,  // 导入loading
			importFilesSubject: false,  // 导入科目
			nowDataRow:{}, // 当前新增行
			expandRow:[],          // 当前展开行
			nowModifyItem: {},       // 当前展开行
			ishandleExpandAll: true,   // 是否全部展开
			isFirstActive: false,
			title:'科目',
			tabVal:"",
			loading:false,
			page:{
				pageIndex:1,
				pageSize:10,
				totall:100,
			},
			tableData:[],
			listLabel:{
				typelist:[],
			},

			dialog:false,
			formDatas:{
				methods:'add',
				type:'',
				creditDirection:'',
			},

      refash:true,
		}
	},
	components:{
		subjectDialog,
		AIImport,
    aiAngry
	},
	created(){
		this.init();
		this.getImportButton();
	},
	computed : {
		getClickCache() {
			return this.$store.state.loadstatus.isClickCache;
		},
	},
	activated() {
		if(this.getClickCache && this.isFirstActive) {
			this.init();
		}
		this.isFirstActive = true;
	},
	methods:{
    ai_success() {
       this.isAIangry = false;
       localStorage.setItem("isAIangry",false)
       this.$refs.AIImports.numbers =0;
       this.$refs.AIImports.dialogVisible = true;
    },
    closeDialog() {
      //window.opener = null;
      //window.open("about:blank", "_self");
    },
    AIangry() {
      this.isAIangry = true;
      localStorage.setItem("isAIangry",true)
    },
		// 获取导入按钮
		getImportButton() {
			let params={
				permissions:'ac:import:subject,book:subject:export',
			}
			try {
				this.$http.post('sys/menu/findPermissionMenu' , params).then(res=>{
					if(res && res.data.code == 1) {
						if(res.data.data.length){
							this.importButton = res.data.data;
						}
					}
				})
			}catch(e){
			}
		},
		// 移出提示
		 beforeRemove(file, fileList) {
       		 return this.$confirm(`确定移除 ${ file.name }？`);
	      },
	      // 传入文件监听
	      OnChange(file,fileList){

	        this.fileList=fileList

	      },
	      // 移出操作
	      OnRemove(file,fileList){
	        this.fileList=fileList
	      },
		// 确认导入
		handleUploadAdd() {
			this.params = new FormData();
			// 导入验证
			if(this.fileList.length>1) {
				return this.$message.warning('只能从列表选择一个上传哟!')
			}
			if(!this.fileList.length) {
				return this.$message.warning('请选择上传文件!')
			}
			let fileOne = this.fileList[0];
			let testmsg=fileOne.name.substring(fileOne.name.lastIndexOf('.')+1)
			const extension = testmsg === 'xls'
			const extension2 = testmsg === 'xlsx'
			const isLt5M = fileOne.size / 1024 / 1024 < 5
			if(!extension && !extension2) {
				return this.$message({
					message: '上传文件只能是 xls、xlsx格式!',
					type: 'warning'
				});
			}
			if(!isLt5M) {
				return this.$message({
					message: '上传文件大小不能超过 5MB!',
					type: 'warning'
				});
			}

			 this.params.append('multipartFile',fileOne.raw);
			 this.params.append('cid',sessionStorage.getItem('cid'));
			 this.params.append('token',sessionStorage.getItem('token'));
			// console.log(this.params.get('multipartFile'))
			// console.log(this.params.get('isArrangement'))
			 try {
			 	const instance = this.$http.create({
			 		withCredentials: true
			 	})
			 	this.isImportFilesLoading = true;

			 	instance.post(this.$rootUrl + 'subject/importFileSubject', this.params).then(res=>{
			 		this.isImportFilesLoading = false;
			 		this.fileList=[];
			 		if(res && (res.data.code == 1 || res.data.code == 99)) {
			 			this.importFilesSubject = false;
			 			if(res.data.code == 1) {
			 				this.$message.success(res.data.msg)
			 			}else {
			 				this.$message.warning(res.data.msg)
			 			}
			 			this.$refs.upload.clearFiles();
			 			this.getData();
			 		}else {
			 			this.$message.error(res.data.msg)
			 			this.$refs.upload.clearFiles();

			 		}
			 	})
			 }catch(e) {

			 }
		},
		// 下载模板
		handleDownload_MB() {
			let cid=sessionStorage.getItem('cid');
		  	let token=sessionStorage.getItem('token');
			window.location.href = this.$rootUrl+'voucherChief/download?cid='+cid+'&token='+token+"&templateName=科目模板.xls";
		},
		// 点击导入  升级智能导入1.0
		importInData(i){
      if(i.permission === "ac:import:subject") { // 导入
        let isAIangry = JSON.parse(localStorage.getItem("isAIangry"));
        if(isAIangry || this.isAIangry) {
          this.$refs.aiAngrys.dialogVisible = true;
          return
        }
        this.$refs.AIImports.dialogVisible = true;
      }else if(i.permission === "book:subject:export") { // 导出
        let params = {
            cid: sessionStorage.cid,
            token: sessionStorage.token,
          }
          const router =this.$router.resolve({
            path: '/export/exportSubject',
            query: params
          })
          window.location.href = this.$rootUrl + router.href;
      }

		},
		handleTableRowStyle(row,rowIndex) {
			if(this.nowDataRow.id) {
				if(row.row.id == this.nowDataRow.id) {
					return {"background":"#eff9f6"}
				}
			}

		},

		// 展开收起
		handleExpandAll() {
			this.ishandleExpandAll = !this.ishandleExpandAll;
			this.refash = false;
			this.$nextTick(()=>{
				this.refash = true;
			})
		},
		init(data){
			//快速访问
			const _=this;
			_.getAllSubjectType();
		},
		getData(){
			const _=this;
			_.$http.post('subject/ajaxgetTree',{
				type:_.tabVal,
				isSubject:"2"
			}).then(res=>{
				let list = res.data.data;
				// for(let i = 0;i<list.length;i++){
				// 	 if(list[i].hasChild){
				// 	 	list[i].hasChildren = true;
				// 	 }
				// };

				_.tableData = list;
				_.loading = false;
			});
		},//获取科目类别
		getAllSubjectType(){
			const _=this;
			_.loading = true;
			let datas = {

			}
			_.$http.post('subject/getSubjectType',datas).then((res)=>{
				if(res && res.data.code == '1'){
					_.listLabel.typelist = res.data.data;
					_.formDatas.type = res.data.data[0];
					_.tabVal= res.data.data[0];
					_.getData();
				}
			}).catch((e)=>{
				_.loading = false;
			})
		},//查询类别子节点
		loadChild(tree, treeNode, resolve){
			const _=this;
			_.loading = true;
			_.$http.post('subject/findChilds',{
					subjectId:tree.id
			}).then((res)=>{
				_.loading = false;
				if(res && res.data.code == '1'){
					let list = res.data.data;
					for(let i = 0;i<list.length;i++){
						if(list[i].hasChild){
							list[i].hasChildren = true;
						}
					};
					resolve([
						...list
					]);

				}
			}).catch((e)=>{
				_.loading = false;
			});
		},//封存
		sealUpEditor(row){
			const _=this;

			const prevent =  this.$getSessionStorage('superPreventOperation');
			if(prevent) {
				this.$store.commit('SUPERPREVENTFUNCTION',true);
				return;
			}
			let strs = row.sealed == '1' ? '解封' : '封存';
			_.$confirm('确定'+ strs + ' '+ row.name +' 这个科目嘛?','提示',{
				confirmButtonText:'确认',
				cancelButtonText:'取消',
				type:'warning'
			}).then(()=>{
				_.$http.post('subject/sealed',{
					id:row.id,
				}).then((res)=>{
					if(res && res.data.code == '1'){
						_.$message({
							message:strs+'成功!',
							type:'success'
						});
						_.getData();
					}
				})
			})
		},//删除
		deleteDelete(row){
			const _=this;

			const prevent =  this.$getSessionStorage('superPreventOperation');
			if(prevent) {
				this.$store.commit('SUPERPREVENTFUNCTION',true);
				return;
			}
			if(!row.initialValue){
				_.$message.error('已被使用，无法删除！');
				return false;
			};
			_.$confirm('确定删除 '+ row.name +' 这个科目嘛?','删除',{
				confirmButtonText:'删除',
				cancelButtonText:'取消',
				type:'warning'
			}).then(()=>{
				_.$http.post('/subject/delSubject',{
					id:row.id
				}).then((res)=>{
					if(res && res.data.code == '1'){

						_.$message({
							message:res.data.msg,
							type:'success'
						})
						_.getData();
					}
				}).catch(()=>{

				})
			})
		},
		addSubject(){//新增科目
			const _=this;

			const prevent =  this.$getSessionStorage('superPreventOperation');
			if(prevent) {
				this.$store.commit('SUPERPREVENTFUNCTION',true);
				return;
			}
			_.dialog = true;
			_.formDatas = {
				methods:'add',
				type:_.tabVal,
				creditDirection:'借',
			};
		},
		addChildEditor(row){//新增下一级科目
			const _=this;

			const prevent =  this.$getSessionStorage('superPreventOperation');
			if(prevent) {
				this.$store.commit('SUPERPREVENTFUNCTION',true);
				return;
			}
			_.dialog = true;
			row.methods = 'newAdd';
			_.formDatas = row;
		},
		editorEditor(row){//修改科目
			const _=this;

			const prevent =  this.$getSessionStorage('superPreventOperation');
			if(prevent) {
				this.$store.commit('SUPERPREVENTFUNCTION',true);
				return;
			}
			_.dialog = true;
			row.methods = 'edit';
			_.formDatas = row;
		},

		handleClick(tab){
			this.tabVal = tab.name;
			this.getData();
		},
		//页码发送变化
		pageIndexChange(page){
			this.page.pageIndex = page;
		},//页码条数发送变化
		pageSizeChange(page){
			this.page.pageSize = page;
		},
		cancel(){
			this.dialog = false;
		},
		loopTableData(arr,id,_a) {
			let a = _a || null ;

			for(var i=0 ; i<arr.length ; i++) {
				if(arr[i].id == id) {
					a = arr[i];
				}else {
					if(arr[i].children) {
						a = this.loopTableData(arr[i].children,id,a)
					}
				}
			}
			return a;
		},
		getRowKeys(row) {
            return row.id;
        },
		cancel1(data){
      if(data == 'edit'){
        this.getData();
      }else{
        this.nowDataRow = data;
        this.dialog = false;
        this.expandRow = [];
        let fatherItem = this.loopTableData(this.tableData , data.fk_superSubject,"")
        this.expandRow.push(fatherItem.id);
        fatherItem.children.push(data);
      }
			//this.getData();
			// this.getData();
		 //      this.refash = false;
		 //      this.$nextTick(()=>{
		 //        this.refash = true;
		 //      });

		}

	},
	mounted() {

	},
}
</script>

<style lang="less">
	#subjectList{
		position: relative;
		height: calc(100% - 122px);
		.table-item-public {
			height: calc(100% - 50px);
		}
    .subjectList-btn {
      position: absolute;
      right: 30px;
      z-index: 100;
    }
		.subject_dialog_import {
			.el-dialog {
				.el-dialog__header {
					padding: 17px 20px;
					border-bottom: 1px solid #E5E5E5;
					.el-dialog__title {
						color: #333;
						font-size: 14px;
						font-weight: 600;
					}

				}
				.el-dialog__body {
					    padding: 18px 20px;
				}
			}
			.fliesUplaod{
				.fliesUplaod_text {
					color: #EC681D;
					display: inline-block;
					margin-bottom: 20px;
				}
				.handleDownload {
					margin: 3px 0 18px 0;
				}
				.uploads{
					padding:15px 0px;
					.el-upload-dragger {
						width: 250px;
						height: 90px;
						.el-icon-upload {
							font-size: 35px;
							margin: 0;
							line-height: 45px;
						}
					}
				}

			}
			.dialog-footer {
					text-align: right;
				}
		}
		.btnAdd{

		}
		.btnAdds{

		}
		.btnAddss{

		}

	}
</style>



// WEBPACK FOOTER //
// src/pages/setting/subjectList.vue